import { useQuery } from '@tanstack/react-query';
import { useApi } from 'contexts/ApiContext';

import type api from 'api';
import type { QueryOptionsFor } from 'hooks/api/types';
import useProjectRoute from 'hooks/useProjectRoute';

export const getBranchesQueryKey = (accountId: string, projectId: string) => {
  return [accountId, projectId, 'branches'];
};

const useBranches = (
  overrideProjectId?: string,
  enabled?: boolean,
  options?: QueryOptionsFor<typeof api.getBranches>,
) => {
  const { accountId, projectId } = useProjectRoute();
  const api = useApi();

  const projectIdToUse = overrideProjectId ?? projectId;

  return useQuery({
    queryFn: () =>
      api.methods.getBranches({ accountId, projectId: projectIdToUse }),
    queryKey: getBranchesQueryKey(accountId, projectIdToUse),
    cacheTime: 0,
    staleTime: 0,
    enabled,
    ...options,
  });
};

export default useBranches;
